<ul class="list-unstyled">
  @for (specGroup of specs; track specGroup) {
    @for (spec of specGroup['items']; track spec) {
      @if (spec && spec.description) {
        <li [ngClass]="{'bg-success text-white px-1':articleService.selectedArticleSpecCode === spec.code}" (click)="highlightSpec(spec.code)">
          <span [innerHTML]="spec.description"></span>
          <b item-end [innerHTML]="spec.value"></b>
        </li>
      }
    }
  }
</ul>
